// Mat-table
export const pageSizeOptions = [10, 20, 40, 50]; //Available options
export const pageSize = 20;  //Initial load


// Html table with custom pagination 
export const paginationForCustomTable = [  //Available options
    { key: 20, viewValue: '20' },
    { key: 40, viewValue: '40' },
    { key: 70, viewValue: '70' },
    { key: 100, viewValue:'100'}
];
export const itemsPerPage = 20; //Initial load

//save table pagination change for auto populate 

export const paginationForItemsPopulate = [  //Available options
    { key: 5, viewValue: '5' },
    { key: 10, viewValue: '10' },
    { key: 25, viewValue: '25' },
    { key: 40, viewValue:'40'}
];
export const itemsPerPageForPopulate = 5; //Initial load


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/e-commerce/pagination.ts